<template>
  <div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--9">
      <div class="col-12 mb-3 mb-xl-0">
        <div class="card shadow">
          <div class="card-header d-xl-flex justify-content-between">
            <h3 class="m-0">Checador</h3>
            <div>
              <base-button @click="modals.workShifts = true" size="sm" icon="fa fa-plus">
                Nuevo Turno
              </base-button>
              <base-button @click="modals.announcements = true" size="sm" icon="fa fa-comment-alt">
                Avisos
              </base-button>
            </div>
          </div>
          <tabs
            ref="tabs"
            tabContentClasses="mb-5"
            tabNavClasses="px-4"
            @tabChanged="openTab"
          >
            <tab title="Checadas">
              <TableChecks v-if="openedTabs.includes(0)" />
            </tab>
            <tab title="Empleados">
              <TableEmployees v-if="openedTabs.includes(1)" />
            </tab>
            <tab title="Turnos">
              <TableWorkShifts v-if="openedTabs.includes(2)" ref="workShifts" />
            </tab>
          </tabs>
        </div>
      </div>
    </div>

    <modal :show.sync="modals.announcements" modal-classes="modal-dialog-centered modal-md">
      <Announcements v-if="modals.announcements"/>
    </modal>

    <modal :show.sync="modals.workShifts" modal-classes="modal-dialog-centered modal-sm">
      <NewWorkShift 
        v-if="modals.workShifts" 
        @close="modals.workShifts = false"
        @success="updateWorkShifts()"
        />
    </modal>
  </div>
</template>
<script>
import Tab from "@/components/Tabs/Tab.vue";
import TableChecks from "./TableChecks.vue";
import TableEmployees from "./TableEmployees.vue";
import Announcements from "./Announcements.vue";
import TableWorkShifts from "./TableWorkShifts.vue";
import NewWorkShift from "./NewWorkShift.vue";
export default {
  components: {
    Tab,
    TableChecks,
    TableEmployees,
    Announcements,
    TableWorkShifts,
    NewWorkShift,
  },
  data() {
    return {
      openedTabs: [],
      modals: {
        announcements: false,
        workShifts: false,
      }
    };
  },
  methods: {
    openTab(params) {
      if (!this.openedTabs.find((tab) => tab === params)) {
        this.openedTabs.push(params);
      }
    },
    updateWorkShifts(){
      this.$refs.tabs.findAndActivateTab('Turnos')

      this.$nextTick(() => {
        this.$refs.workShifts.getWorkShifts();
      })
    }
  },
};
</script>
<style>
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background: linear-gradient(87deg, #f5365cd7 0, #f55f36d3 200%) !important;
}
.nav-pills .nav-link {
  font-weight: 600 !important;
}
</style>
